import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { CnCodeEditorCore } from 'src/components/cn-code-editor-core';
import OperatorPanel from './widgets/OperatorPanel';
import SidePanel from './widgets/SidePanel';
import TabBar from './widgets/TabBar';
import './scss/editor.scss';
const clsPrefix = `cn-code-editor`;
const CnCodeEditor = forwardRef((props, editorRef) => {
    const { className, style, language, value, operationPanelConfig, editorOptions, onCreated, onChange, sqlOptions, tabBarConfig, sideBarConfig, supportLanguages, } = props;
    const [proxyValue, setProxyValue] = useState();
    const [isEditorInit, setIsEditorInit] = useState(false);
    useEffect(() => {
        if (isEditorInit) {
            setProxyValue(value);
        }
    }, [isEditorInit, value]);
    const hasOperatorPanel = useMemo(() => {
        return (operationPanelConfig?.operations || operationPanelConfig?.title || operationPanelConfig?.extra);
    }, [operationPanelConfig]);
    const hasSideSettings = useMemo(() => {
        return sideBarConfig?.settings?.length;
    }, [sideBarConfig]);
    const hasTabBarConfig = useMemo(() => {
        return tabBarConfig?.tabs?.length;
    }, [tabBarConfig]);
    const handleCreated = (editor, clearCache) => {
        setIsEditorInit(true);
        onCreated && onCreated(editor, clearCache);
    };
    return (<div className={classNames(`${clsPrefix}`, { [`${clsPrefix}-no-widgets`]: !hasOperatorPanel && !hasSideSettings && !hasTabBarConfig }, { [`${clsPrefix}-no-radius`]: !hasOperatorPanel || !hasTabBarConfig }, className)} style={style}>
      <OperatorPanel {...operationPanelConfig}/>
      <div className={`${clsPrefix}-content`}>
        <div className={`${clsPrefix}-main`}>
          {/* FIXME:暂时用key触发remount解决语言切换service未切换问题 */}
          <CnCodeEditorCore className={`${clsPrefix}-full-fill`} key={language} ref={editorRef} language={language} supportLanguages={supportLanguages} value={proxyValue} editorOptions={editorOptions} sqlOptions={sqlOptions} onCreated={handleCreated} onChange={onChange}/>
          <SidePanel {...sideBarConfig}/>
        </div>
        <TabBar {...tabBarConfig}/>
      </div>
    </div>);
});
CnCodeEditor.displayName = 'CnCodeEditor';
export { CnCodeEditor };
